module.exports = __webpack_public_path__ + "img/icon_arrow.1dd619c9.svg";